// removed by extract-text-webpack-plugin
module.exports = {"red":"#e40000","black":"#000000","white":"#ffffff","container":"_2JYZX1AR6j-v3fNltWy6nX","simple":"_2ikygrb2fB4nwQ_VjVt1zR","large":"_7WSizAAAETLp5Oftbye7j","title":"_2jwbc7EYOOncJWrvnXJGih","dark":"yDRCIfFLQS0OvQR-9pQHB","msg":"_3zrWc3x7erlQApb3zho18m","spinner":"_28Q2yWi0RNs8E8nBZb6g2X","rotate":"GUVzkNWbWzHib0CYWcpUR","path":"_3rrFYFi2Rxb7cHT9LFJKoF","dash":"_1bNuWrZrm3DsU-rRLEjroO"};


//////////////////
// WEBPACK FOOTER
// ./src/uis/elements/Loading/Loading.css
// module id = 981
// module chunks = 0